/**
 * MCP Sync API Client
 *
 * Frontend API for triggering sync operations that persist MCP server
 * capabilities (tools, resources, prompts) to Convex database.
 */

export type SyncStats = {
  added: number;
  updated: number;
  inactivated: number;
  totalCurrent: number;
};

export type SyncResponse = {
  success: boolean;
  stats: SyncStats;
  error?: string;
};

async function syncEntity(
  entityType: "tools" | "resources" | "prompts",
  serverId: string,
  authToken?: string,
): Promise<SyncResponse> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  const response = await fetch(`/api/mcp/${entityType}/syncToDb`, {
    method: "POST",
    headers,
    body: JSON.stringify({ serverId }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || `Sync failed with status ${response.status}`);
  }

  return data;
}

export const syncTools = (serverId: string, authToken?: string) =>
  syncEntity("tools", serverId, authToken);

export const syncResources = (serverId: string, authToken?: string) =>
  syncEntity("resources", serverId, authToken);

export const syncPrompts = (serverId: string, authToken?: string) =>
  syncEntity("prompts", serverId, authToken);
